export const STORY_REEL_STORY_TYPES = ["reel", "igtv"] as const;
export const VIDEO_TYPES = ["video"] as const;
export const IMAGE_TYPES = ["image", "photo"] as const;
export const FB_REEL_TYPE = "fb-reel";
export const DOCUMENT_URL_PATTERN = /\.pdf/;
export const VIDEO_URL_PATTERN = /\.mp4/;
export const SHORTS_PATTERN = /#shorts/i;

/** Platforms whose videos are Reels / short video. */
export const REEL_PLATFORMS = ["IG", "TT"] as const;
export const SHORTS_PLATFORM = "YT";
